// Mock data for About/History page

export const aboutADIPSI = {
  title: "Tentang ADIPSI",
  description: "Asosiasi Dosen Ilmu Pemerintahan Seluruh Indonesia (ADIPSI) adalah organisasi profesi yang menghimpun para dosen dan akademisi di bidang Ilmu Pemerintahan dari berbagai perguruan tinggi di Indonesia.",
  history: [
    {
      year: "2010",
      title: "Pendirian ADIPSI",
      description: "ADIPSI didirikan sebagai wadah komunikasi dan kolaborasi para dosen Ilmu Pemerintahan di Indonesia. Berawal dari pertemuan informal di Jakarta, para dosen dari berbagai universitas sepakat membentuk asosiasi profesional."
    },
    {
      year: "2012",
      title: "Kongres Pertama",
      description: "Kongres pertama ADIPSI diselenggarakan di Bandung dengan dihadiri 50 dosen dari 20 universitas. Menghasilkan AD/ART dan struktur organisasi yang solid."
    },
    {
      year: "2015",
      title: "Kerjasama Internasional",
      description: "ADIPSI menjalin kerjasama dengan International Political Science Association (IPSA) dan berbagai asosiasi sejenis di Asia Tenggara."
    },
    {
      year: "2018",
      title: "Akreditasi Program Studi",
      description: "ADIPSI berperan aktif dalam proses akreditasi program studi Ilmu Pemerintahan di Indonesia dan menjadi mitra BAN-PT."
    },
    {
      year: "2020",
      title: "Transformasi Digital",
      description: "Adaptasi pandemi dengan mengembangkan platform digital untuk seminar, workshop, dan kolaborasi penelitian online."
    },
    {
      year: "2024",
      title: "Era Baru ADIPSI",
      description: "ADIPSI kini beranggotakan lebih dari 300 dosen dari 80+ universitas di seluruh Indonesia dengan berbagai program pengembangan SDM dan penelitian kolaboratif."
    }
  ]
};

export const leaderships = [
  {
    id: 1,
    period: "2010-2013",
    chairman: "Prof. Dr. Ahmad Hidayat, M.Si",
    university: "Universitas Indonesia",
    achievement: "Membangun fondasi organisasi dan memperluas jaringan ke 20 universitas"
  },
  {
    id: 2,
    period: "2013-2016",
    chairman: "Prof. Dr. Siti Nurjanah, M.AP",
    university: "Universitas Gadjah Mada",
    achievement: "Mengembangkan kerjasama internasional dan jurnal ilmiah nasional"
  },
  {
    id: 3,
    period: "2016-2019",
    chairman: "Dr. Budi Santoso, S.IP., M.Si",
    university: "Universitas Brawijaya",
    achievement: "Meningkatkan peran dalam akreditasi program studi dan penelitian kolaboratif"
  },
  {
    id: 4,
    period: "2019-2022",
    chairman: "Prof. Dr. Dewi Kusuma, M.PA",
    university: "Universitas Diponegoro",
    achievement: "Transformasi digital dan perluasan anggota ke Indonesia Timur"
  },
  {
    id: 5,
    period: "2022-Sekarang",
    chairman: "Prof. Dr. Rudi Hermawan, S.IP., M.Si",
    university: "Universitas Padjadjaran",
    achievement: "Memperkuat kolaborasi riset dan pengembangan kurikulum berbasis kompetensi"
  }
];

export const membershipGrowth = [
  { year: "2010", members: 45, universities: 15 },
  { year: "2012", members: 78, universities: 25 },
  { year: "2014", members: 115, universities: 35 },
  { year: "2016", members: 158, universities: 48 },
  { year: "2018", members: 195, universities: 58 },
  { year: "2020", members: 242, universities: 68 },
  { year: "2022", members: 285, universities: 75 },
  { year: "2024", members: 325, universities: 82 }
];

export const visionMission = {
  vision: "Menjadi asosiasi profesional dosen Ilmu Pemerintahan yang unggul, inovatif, dan berperan aktif dalam pengembangan ilmu pengetahuan dan pembangunan tata kelola pemerintahan yang baik di Indonesia.",
  missions: [
    "Meningkatkan kualitas pendidikan dan pengajaran Ilmu Pemerintahan di Indonesia",
    "Mengembangkan penelitian dan publikasi ilmiah berkualitas tinggi",
    "Memfasilitasi kolaborasi antar dosen dan lembaga pendidikan",
    "Memberikan kontribusi pemikiran untuk kebijakan publik dan tata kelola pemerintahan",
    "Membangun jaringan kerjasama nasional dan internasional"
  ]
};